export const Footer=()=>
{

    return(

        <>
        
            <div className="footer wow fadeIn" data-wow-delay="0.3s">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-3">
                            <div className="footer-contact">
                                <h2>Office Contact</h2>
                                <p><i className="fa fa-map-marker-alt"></i>
                                    Plot 185 Mercy Lane
                                    Federal Housing Authority Estate
                                    off Peter Odili Road, Trans-Amadi
                                    Port Harcourt, Rivers State
                                    Nigeria
                                </p>
                                <p><i className="fa fa-phone-alt"></i>+234 806 222 1110</p>
                                <p><i className="fa fa-envelope"></i>info@frantinogroup.com</p>
                                <div className="footer-social">
                                    <a href=""><i className="fab fa-twitter"></i></a>
                                    <a href=""><i className="fab fa-facebook-f"></i></a>
                                    <a href=""><i className="fab fa-youtube"></i></a>
                                    <a href=""><i className="fab fa-instagram"></i></a>
                                    <a href=""><i className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="footer-link">
                                <h2>Services</h2>                                
                                <a href="">Engineering Design</a>
                                <a href="">Construction </a>
                                <a href="">Strategic Procurement</a>
                                <a href="">Road/Building Construction</a>
                                <a href="">Pipeline/Flowline Construction, Sectional Replacement and Leak Repair/Maintenance Works</a>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="footer-link">
                                <h2>Useful Links</h2>
                                <a href="">About Us</a>
                                <a href="">Contact Us</a>
                                <a href="">Our Team</a>
                                <a href="">Projects</a>
                                
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="newsletter">
                                <h2>Newsletter</h2>
                                <p>
                                    You can subscribe to our monthly news letters.
                                </p>
                                <div className="form">
                                    <input className="form-control" placeholder="Email here" />
                                    <button className="btn">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container footer-menu">
                    <div className="f-menu">
                        <a href="">Terms of use</a>
                        <a href="">Privacy policy</a>
                        <a href="">Cookies</a>                       
                        <a href="">FQAs</a>
                    </div>
                </div>
                <div className="container copyright">
                    <div className="row">
                        <div className="col-md-6">
                            <p>&copy; <a href="#">Frantino Multiple Services Ltd</a>, All Right Reserved.</p>
                        </div>
						
						
                        <div class="col-md-6">
                            <p>Designed By <a href="http://www.ogidel.com">Ogidel</a></p>
                        </div>
                    </div>
                </div>
            </div>
          
        </>
    )
}